export default "__VITE_ASSET__DdP$supx__"